import { FormGroup } from "@angular/forms";
import { MetaData } from "@app/models/backend";
// import { ControlItem } from "@app/models/frontend";

export const markFormGroupTouched = (formGroup: FormGroup) => {
    (Object as any).values(formGroup.controls).forEach((control: { markAsTouched: () => void; controls: any; } | any) => {
        control.markAsTouched();

        if (control.controls) {
            markFormGroupTouched(control);
        }
    })
}

export interface Control {
    // items?: ControlItem[];
    items?: any[];
    // items?: MetaData["RegBusiness"]["province"];
    changed?: () => void;
    map?: () => void;
}

export interface ControlEntities {
    [key: string]: Control | any ;
}

export const mapControls = (controls: ControlEntities): void => {
    Object.keys(controls).forEach(key => {
        if(controls[key]?.map) {
            controls[key]?.map();
        }
    })
}